export const THEME_STORAGE_KEY = "themeMode";

export const THEME_MODES = {
  SYSTEM: "system",
  LIGHT: "light",
  DARK: "dark",
};

export const ACTIVE_ACCENT_COLOR = "#103B38";

export function getStoredThemeMode() {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (
    stored === THEME_MODES.LIGHT ||
    stored === THEME_MODES.DARK ||
    stored === THEME_MODES.SYSTEM
  ) {
    return stored;
  }
  return THEME_MODES.SYSTEM;
}

export function getSystemPrefersDark() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

/** @returns {"apple" | "windows"} */
export function getClientOsFamily() {
  if (typeof navigator === "undefined") {
    return "windows";
  }

  const ua = navigator.userAgent || "";
  const platform =
    navigator.userAgentData?.platform || navigator.platform || "";

  if (
    /Mac|iPhone|iPad|iPod/i.test(platform) ||
    /Mac OS X|Macintosh/i.test(ua)
  ) {
    return "apple";
  }

  if (/Win/i.test(platform) || /Windows/i.test(ua)) {
    return "windows";
  }

  return "windows";
}

export function resolveIsDark(mode) {
  if (mode === THEME_MODES.LIGHT) return false;
  if (mode === THEME_MODES.DARK) return true;
  return getSystemPrefersDark();
}

export function applyDocumentTheme(isDark) {
  const themeName = isDark ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", themeName);
  document.body.style.backgroundColor = isDark ? "#000000" : "#f5f7f8";
}
